import styles from "gui/answers/answers.module.css";
import { Cell } from "gui/grid/cell";
import { Grid } from "gui/grid/grid";
import { Icon } from "gui/icon/icon";
import { SanityAnswers } from "lib/sanity/types";
import { Subtitle } from "gui/subtitle/subtitle";
import { TextBlocks } from "gui/text/text";

export const Answers: React.FC<{
  item: SanityAnswers;
}> = (props) => {
  const id = `aria-${props.item._key}`;

  return (
    <Grid aria-labelledby={id} revealOnScroll>
      <Subtitle id={id} text={props.item.title} />
      {props.item.list.map((element, i) => (
        <Answer key={i} item={props.item} element={element} index={i} />
      ))}
    </Grid>
  );
};

const Answer: React.FC<{
  item: SanityAnswers;
  element: SanityAnswers["list"][0];
  index: number;
}> = (props) => {
  const id = `aria-${props.item._key}-${props.index}`;

  return (
    <Cell as="article" span6="lg" aria-labelledby={id} className={styles.item}>
      <h3 id={id} className={styles.question}>
        <Icon icon="question" />
        {props.element.question}
      </h3>
      <TextBlocks className={styles.answer} blocks={props.element.answer} />
    </Cell>
  );
};
